import {useContext} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import NivelesEstructureContext from 'context/NivelesEstructureContext';

let myAbilities = HelpAbility();

function Item({i, nivel: ni, deleteNivelEstructure}){
    
 const {setNivelEstructure} = useContext(NivelesEstructureContext);
 const {_id, nivel, tramas, flujo} = ni;

 const handleIsUpdateForm = () => {
    const newNivel = {
        _id,
        nivel,
        tramas: JSON.stringify(tramas),
        flujo
    }
    setNivelEstructure({...newNivel})
 }
 
 const handleDeleteNivelEstructure = async () => {
    deleteNivelEstructure({id: _id})
 }


 return (
   <tr>
      <th className="text-center" scope="row">{i + 1}</th>
      <td className="text-center">{nivel}</td>
      <td className="text-center"><pre>{JSON.stringify(tramas,0 , 4)}</pre></td>
      <td className="text-center">{flujo === "barrio-manzana" ? "Barrio Manzana" : flujo === "calle-carrera" ? "Calle Carrera" : "N/A"}</td>

      {myAbilities.hasAny([C.A.NIVELESSTRUCTURE.UPDATE, C.A.NIVELESSTRUCTURE.DELETE]) && <td className="text-center d-flex">
          {myAbilities.has(C.A.NIVELESSTRUCTURE.UPDATE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={handleIsUpdateForm}>
                  <i className="bi bi-pencil-square"/>
              </button>
          </OverlayTrigger>}
          {myAbilities.has(C.A.NIVELESSTRUCTURE.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-danger"
                      onClick={handleDeleteNivelEstructure}>
                  <i className="bi bi-trash"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item

